export const DOCUMENT_LIBRARY_CATEGORIES = Object.freeze([
  { key: "photo_evidence", label: "Foto / bewijs" },
  { key: "measurement_report", label: "Meetrapport" },
  { key: "material_receipt", label: "Materiaalbon" },
  { key: "supplier_document", label: "Leveranciersdocument" },
  { key: "drawing_revision", label: "Revisie / tekening" },
  { key: "safety_toolbox", label: "Veiligheid / toolbox" },
  { key: "permit_access", label: "Vergunning / toegang" },
  { key: "customer_document", label: "Klantdocument" },
  { key: "delivery_document", label: "Opleverdocument" },
  { key: "other", label: "Overig" },
]);

export const DOCUMENT_LIBRARY_CATEGORY_BY_KEY = Object.freeze(
  DOCUMENT_LIBRARY_CATEGORIES.reduce((acc, item) => {
    acc[item.key] = item;
    return acc;
  }, {})
);

